import { MinusIcon } from '@velasca/icons/minus'
import { PlusIcon } from '@velasca/icons/plus'
import { SansText } from '../SansText/SansText'
import { Collapser, IconContainer } from './ReadMore.styles'
import type { ReadMoreProps } from './ReadMore.types'

export const ReadMore = ({
  title,
  isOpen,
  onClick,
  className,
}: ReadMoreProps): JSX.Element => {
  return (
    <Collapser className={className} onClick={onClick}>
      <IconContainer>{isOpen ? <MinusIcon /> : <PlusIcon />}</IconContainer>
      <SansText as="span">{title}</SansText>
    </Collapser>
  )
}
